import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Collecting Applications\n          ")
], -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-blue-700" }, "Please attach any relevant documentation including applications and the shortlisting matrix.", -1);
const _hoisted_6 = { class: "grid grid-cols-3 gap-6 sm:pt-5 mt-4" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", null, "All applications attached? *", -1);
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { class: "mt-4 space-y-4" };
const _hoisted_10 = { class: "flex items-start" };
const _hoisted_11 = { class: "h-5 flex items-center" };
const _hoisted_12 = ["checked", "disabled"];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "applications_attached",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_14 = { class: "flex items-start" };
const _hoisted_15 = { class: "h-5 flex items-center" };
const _hoisted_16 = ["checked", "disabled"];
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "applications_attached",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_18 = { class: "grid grid-cols-3 gap-6 sm:pt-5 mt-4" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("p", null, "Shortlisting matrix attached? *", -1);
const _hoisted_20 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_21 = { class: "mt-4 space-y-4" };
const _hoisted_22 = { class: "flex items-start" };
const _hoisted_23 = { class: "h-5 flex items-center" };
const _hoisted_24 = ["checked", "disabled"];
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "matrix_attached",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_26 = { class: "flex items-start" };
const _hoisted_27 = { class: "h-5 flex items-center" };
const _hoisted_28 = ["checked", "disabled"];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "matrix_attached",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_30 = { class: "grid grid-cols-3 gap-6 sm:pt-5 mt-4" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("p", null, "Shortlisting complete? *", -1);
const _hoisted_32 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_33 = { class: "mt-4 space-y-4" };
const _hoisted_34 = { class: "flex items-start" };
const _hoisted_35 = { class: "h-5 flex items-center" };
const _hoisted_36 = ["checked", "disabled"];
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shortlisting_complete",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_38 = { class: "flex items-start" };
const _hoisted_39 = { class: "h-5 flex items-center" };
const _hoisted_40 = ["checked", "disabled"];
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shortlisting_complete",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_42 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_43 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FileUploader = _resolveComponent("FileUploader");
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _hoisted_5,
                _createTextVNode(),
                _createVNode(_component_FileUploader, {
                    name: "collecting-applications",
                    disabled: _ctx.disableForm,
                    files: _ctx.data?.collectingApplications?.files,
                    "document-short-id": _ctx.data.shortId,
                    uploading: _ctx.uploading,
                    onUpdateFiles: _ctx.handleUpdateFiles,
                    onFileUploading: _cache[0] || (_cache[0] = ($event) => (_ctx.uploading = $event))
                }, null, 8, ["disabled", "files", "document-short-id", "uploading", "onUpdateFiles"]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("fieldset", null, [
                        _createElementVNode("div", null, [
                            _hoisted_7,
                            _createTextVNode(),
                            (_ctx.v$.data?.collectingApplications.applications_attached.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n                  * " + _toDisplayString(_ctx.v$.data?.collectingApplications.applications_attached.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("input", {
                                        id: "radio-button-applications_attached_yes",
                                        name: "applications_attached",
                                        type: "radio",
                                        value: "Yes",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                        checked: _ctx.data.collectingApplications?.applications_attached === 'Yes',
                                        disabled: _ctx.disableForm,
                                        onChange: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[2] || (_cache[2] = ($event) => (_ctx.v$.data?.collectingApplications.applications_attached.$touch()))
                                    }, null, 42, _hoisted_12)
                                ]),
                                _createTextVNode(),
                                _hoisted_13
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("input", {
                                        id: "radio-button-applications_attached_no",
                                        name: "applications_attached",
                                        type: "radio",
                                        value: "No",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                        checked: _ctx.data.collectingApplications?.applications_attached === 'No',
                                        disabled: _ctx.disableForm,
                                        onChange: _cache[3] || (_cache[3] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[4] || (_cache[4] = ($event) => (_ctx.v$.data?.collectingApplications.applications_attached.$touch()))
                                    }, null, 42, _hoisted_16)
                                ]),
                                _createTextVNode(),
                                _hoisted_17
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("fieldset", null, [
                        _createElementVNode("div", null, [
                            _hoisted_19,
                            _createTextVNode(),
                            (_ctx.v$.data?.collectingApplications.matrix_attached.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "\n                  * " + _toDisplayString(_ctx.v$.data?.collectingApplications.matrix_attached.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("input", {
                                        id: "radio-button-matrix_attached_yes",
                                        name: "matrix_attached",
                                        type: "radio",
                                        value: "Yes",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                        checked: _ctx.data.collectingApplications?.matrix_attached === 'Yes',
                                        disabled: _ctx.disableForm,
                                        onChange: _cache[5] || (_cache[5] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[6] || (_cache[6] = ($event) => (_ctx.v$.data?.collectingApplications.matrix_attached.$touch()))
                                    }, null, 42, _hoisted_24)
                                ]),
                                _createTextVNode(),
                                _hoisted_25
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("input", {
                                        id: "radio-button-matrix_attached_no",
                                        name: "matrix_attached",
                                        type: "radio",
                                        value: "No",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                        checked: _ctx.data.collectingApplications?.matrix_attached === 'No',
                                        disabled: _ctx.disableForm,
                                        onChange: _cache[7] || (_cache[7] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.v$.data?.collectingApplications.matrix_attached.$touch()))
                                    }, null, 42, _hoisted_28)
                                ]),
                                _createTextVNode(),
                                _hoisted_29
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("fieldset", null, [
                        _createElementVNode("div", null, [
                            _hoisted_31,
                            _createTextVNode(),
                            (_ctx.v$.data?.collectingApplications.shortlisting_complete.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "\n                  * " + _toDisplayString(_ctx.v$.data?.collectingApplications.shortlisting_complete.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("input", {
                                        id: "radio-button-shortlisting_complete_yes",
                                        name: "shortlisting_complete",
                                        type: "radio",
                                        value: "Yes",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                        checked: _ctx.data.collectingApplications?.shortlisting_complete === 'Yes',
                                        disabled: _ctx.disableForm,
                                        onChange: _cache[9] || (_cache[9] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.v$.data?.collectingApplications.shortlisting_complete.$touch()))
                                    }, null, 42, _hoisted_36)
                                ]),
                                _createTextVNode(),
                                _hoisted_37
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("input", {
                                        id: "radio-button-shortlisting_complete_no",
                                        name: "shortlisting_complete",
                                        type: "radio",
                                        value: "No",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                        checked: _ctx.data.collectingApplications?.shortlisting_complete === 'No',
                                        disabled: _ctx.disableForm,
                                        onChange: _cache[11] || (_cache[11] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[12] || (_cache[12] = ($event) => (_ctx.v$.data?.collectingApplications.shortlisting_complete.$touch()))
                                    }, null, 42, _hoisted_40)
                                ]),
                                _createTextVNode(),
                                _hoisted_41
                            ])
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            (_ctx.profile?.RESOURCING && _ctx.data.currentStageName === 'starter.notifyRoleAdvertised')
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid || _ctx.uploading,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Next\n        ", 8, _hoisted_43)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
